//#region imports
import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthenticationService } from '@app/member-response-portal/service/authentication.service';
//#endregion imports
@Component({
  selector: 'app-unsaved-changes-dialog',
  templateUrl: './unsaved-changes-dialog.component.html',
  styleUrls: ['./unsaved-changes-dialog.component.scss']
})
export class UnsavedChangesDialogComponent {
    constructor(
        private dialogRef: MatDialogRef<UnsavedChangesDialogComponent>,
        private authenticationService: AuthenticationService,) {
    }

    public OnLeave() : void {
        this.dialogRef.close(true);
        this.authenticationService.LogoutAndRedirectToLogin();
    }

    public OnStay() : void {
        this.dialogRef.close(false);
    }
}
